import React from "react";
import Footer from "./Footer";
import GetInTouchFooter from "./GetInTouchFooter";
import CustomHeading from "./custom/CustomHeading.js";
import CustomContent from "./custom/CustomContent.js";
import Stages from "./Programs/Stages.js";
import { Helmet } from "react-helmet";

const Programs = () => {
  window.scrollTo(0, 20);
  return (
    <div>
      <Helmet>
        <title>
          Preschool Programs at Mother's Pride - Age-Specific Learning
        </title>
        <meta
          name="description"
          content="Explore Mother's Pride's specially designed preschool programs for different age groups, fostering holistic development through structured learning."
        />
        <meta
          name="keywords"
          content="preschool facilities, safe school environment, learning infrastructure, child-friendly preschool, nurturing space"
        />
        <link
          rel="canonical"
          href="https://www.motherspridepreschool.com/programs"/>
      </Helmet>
      <div className=" pt-[6%] flex flex-col gap-2 sm:gap-5 ">
        <CustomHeading
          text={"Our Programmes"}
          textSize={"70px"}
          textColor={"#D31C4F"}
          showHeart={true}
          heartPosition={"absolute"}
          textAlign={"center"}
          smTextSize="32px"
          heartMarginLeft={window.innerWidth < 450 ? "2px" : "10px"}
        />
        <CustomContent
          text={"A culmination of all the best teaching methods in the world"}
          textAlign="center"
        />
        <Stages />

        <div>
          <GetInTouchFooter marginX={"4%"} />
        </div>
        <div>
          <Footer marginX={"4%"} />
        </div>
      </div>
    </div>
  );
};

export default Programs;
